export const stacking = {
  zIndexControls: 1,
  zIndexControlsPriority: 2,
  zIndexOverlay: 3,
  zIndexExtra: 4,
  zIndexExtraHigh: 5
};